import React, {
	useEffect,
	useState,
} from 'react';
import { Card } from 'antd';
import {
	BankAccountTypes,
	CustomFieldParentTypes,
} from '@shared/utils/constants';
import type { BankAccountWithCurrencyFlag } from '@api/features/vessels/getVesselDetails';
import { BankAccountTabs } from '@client/screens/fleet/VesselDetailsScreen/components/BankAccountTabs';
import useVesselBankAccountHandlers from '@client/screens/fleet/VesselDetailsScreen/hooks/useVesselBankAccountHandlers';
import CustomFields from '@client/screens/management/banking/CustomFields/CustomFields';
import { createBankAccount } from '@client/lib/api';

type Props = {
	vesselId: number;
	bankAccounts: BankAccountWithCurrencyFlag[];
	onChange: () => Promise<unknown> | void;
	title?: string;
	className?: string;
};

const VesselOurBankAccounts = ({
	vesselId,
	bankAccounts,
	onChange,
	title = 'Your Banking Details',
	className,
}: Props) => {
	const [activeTab, setActiveTab] = useState<number | undefined>(undefined);
	const {
		onSaveBankAccount,
		onDeleteBankAccount,
	} = useVesselBankAccountHandlers(vesselId, onChange);

	useEffect(() => {
		if (!activeTab || !bankAccounts.some((account) => account.id === activeTab)) {
			setActiveTab(bankAccounts.length > 0 ? bankAccounts[0].id : undefined);
		}
	}, [activeTab, bankAccounts]);

	const onAddBankAccount = async () => {
		const newAccount = await createBankAccount(BankAccountTypes.OURS, vesselId);
		await onChange();

		return newAccount;
	};

	return (
		<Card
			bordered
			title={title}
			className={className}
		>
			<BankAccountTabs
				activeBankAccountTab={activeTab}
				setActiveBankAccountTab={setActiveTab}
				bankAccounts={bankAccounts}
				deleteBankAccount={onDeleteBankAccount}
				addBankAccount={onAddBankAccount}
				saveBankAccount={onSaveBankAccount}
				allowCreate
				showInvoiceCompanyName
			/>
			{activeTab && (
				<CustomFields
					parentId={Number(activeTab)}
					parentType={CustomFieldParentTypes.BANK}
				/>
			)}
		</Card>
	);
};

export default VesselOurBankAccounts;
